module.exports = __webpack_public_path__ + "img/succeicon.50840b55.png";